export const DATA = ['data'];
export const ERROR = ['error'];
export const STATUS = ['status'];
export const UPDATED_AT = ['updatedAt'];